

import { pageSizes, pickerOptionsToday, PAY_TYPE_OPTIONSS, PAY_TYPE_OPTIONSSS, STAT_TYPES } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { setToday } from '@/utils/filter';
import { BigNumber } from 'bignumber.js';
import setUrl from '@/mixins/setUrl';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'wait-fee',
  mixins: [pageSize, setUrl],
  data() {
    return {
      pageSizes,
      pickerOptionsToday,
      active: 0,
      activeS: 0,
      doctorName: '',
      tableData: [], // 订单统计列表
      profitTableData: [], // 利润统计列表
      payTypes: PAY_TYPE_OPTIONSS,
      PAY_TYPE_OPTIONSSS,
      statTypes: STAT_TYPES,
      total: 0, // 订单统计总数据条数
      profitTotal: 0, // 利润统计总数据条数
      time2: [], // 利润统计查询时间
      query: {
        pageSize: 20,
      },
      queryProfit: {
        doctorId: null, // 医生id
        orderType: 0, // 订单类型
        payMode: 0, // 付款方式
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      }, // 利润查询参数
      profitStreamInfo: {
        totalOrderAmount: 0, // 订单总金额
        preferentialAmount: 0, // 优惠金额
        receivableAmount: 0, // 应收金额
        cost: 0, // 成本
        profit: 0, // 创造利润
        doctorProfit: [],
      },
      doctorOptions: [{
        doctorId: null,
        realName: '全部',
      }],
      profitChartData: {
        columns: ['日期', '订单金额', '利润'],
        rows: [],
      },
    };
  },
  methods: {
    // 获取利润统计
    getProfit(type) {
      const newTime = setToday();
      console.log(newTime);
      this.queryProfit.startTime = this.time2 ? this.time2[0] : '';
      this.queryProfit.endTime = this.time2 ? this.time2[1] : '';
      this.queryChangeHandle();
      if (this.queryProfit.startTime === newTime[0]) {
        this.getProfitCurrentDayData(type);
      } else {
        this.getProfitStream(type);
      }
    },
    // 获取利润流水信息-当日
    getProfitCurrentDayData(type) {
      this.$api.statistic.getProfitCurrentDayData({
        ...this.queryProfit,
        doctorId: null,
      }).then((res) => {
        console.log(res);
        this.profitStreamInfo = res;
        this.profitStreamInfo.doctorProfit.unshift({
          doctorId: null,
          doctorName: this.$store.state.global.countInfo.hospitalName,
          hospitalId: this.$store.state.global.countInfo.hospitalId,
          orderTotalSum: this.profitStreamInfo.totalOrderAmount,
          profit: this.profitStreamInfo.profit, // 创造利润
          visits: this.profitStreamInfo.visits, // 就诊人数
          drugSaleAmount: this.profitStreamInfo.drugSaleAmount, // 药品销售额
          examSaleAmount: this.profitStreamInfo.examSaleAmount, // 检查销售额
          additionSaleAmount: this.profitStreamInfo.additionSaleAmount, // 附加费销售额
        }); // 数组第一条显示诊所总数据
        const newList = this.sliceArray(this.profitStreamInfo.doctorProfit, 4); // 医生信息分组（配合组件使用）
        this.profitStreamInfo.doctorProfit = newList;
        this.profitChartData.rows = res.chartData.map(item => ({
          '日期': item.time,
          '订单金额': item.totalSum,
          '利润': item.profit,
        }));
        this.$refs.chart2.echarts.resize();
      });
      this.getProfitTableData(type);
    },
    // 获取利润流水信息
    getProfitStream(type) {
      this.$api.statistic.profit({
        ...this.queryProfit,
        doctorId: null,
      }).then((res) => {
        console.log(res);
        this.profitStreamInfo = res;
        this.profitStreamInfo.doctorProfit.unshift({
          doctorId: null,
          doctorName: this.$store.state.global.countInfo.hospitalName,
          hospitalId: this.$store.state.global.countInfo.hospitalId,
          orderTotalSum: this.profitStreamInfo.totalOrderAmount,
          profit: this.profitStreamInfo.profit,
          visits: this.profitStreamInfo.visits, // 就诊人数
          drugSaleAmount: this.profitStreamInfo.drugSaleAmount, // 药品销售额
          examSaleAmount: this.profitStreamInfo.examSaleAmount, // 检查销售额
          additionSaleAmount: this.profitStreamInfo.additionSaleAmount, // 附加费销售额
        }); // 数组第一条显示诊所总数据
        const newList = this.sliceArray(this.profitStreamInfo.doctorProfit, 4); // 医生信息分组（配合组件使用）
        this.profitStreamInfo.doctorProfit = newList;
        this.profitChartData.rows = res.chartData.map(item => ({
          '日期': item.time,
          '订单金额': item.totalSum,
          '利润': item.profit,
        }));
        this.$refs.chart2.echarts.resize();
      });
      this.getProfitTableData(type);
    },
    // 获取利润列表信息
    getProfitTableData(type) {
      if (type === 1) this.queryProfit.currentPage = 1;
      this.queryProfit.startTime = this.time2 ? this.time2[0] : '';
      this.queryProfit.endTime = this.time2 ? this.time2[1] : '';
      this.$api.statistic.listOrderProfit({
        ...this.queryProfit,
      }).then((res) => {
        console.log(res);
        this.profitTableData = res.list;
        this.profitTotal = res.totalSize;
      });
    },
    // 获取诊所医生
    getDoctorId() {
      this.$api.statistic.getDoctors().then((res) => {
        this.doctorOptions = [...this.doctorOptions, ...res];
      });
    },
    // 选择医生
    select(item, index, indexs) {
      this.active = index;
      this.activeS = indexs;
      this.doctorName = item.doctorName;
      this.queryProfit.doctorId = (item && item.doctorId) || null;
      this.getProfitTableData(1);
    },
    /*
    * 将一个数组分成几个同等长度的数组
    * array[分割的原数组]
    * size[每个子数组的长度]
    */
    sliceArray(array, size) {
      const result = [];
      for (let x = 0; x < Math.ceil(array.length / size); x++) {
        const start = x * size;
        const end = start + size;
        result.push(array.slice(start, end));
      }
      return result;
    },
    // 跳转收费详情
    gotoFeeDetail(item) {
      this.$router.push({ path: '/statistics/feeDetail', query: { id: item, isEdit: 0 } });
    },
    // 每页展示数据条数变更
    ProfitHandleSizeChange(val) {
      this.queryProfit.pageSize = val;
      this.getProfit(1);
    },
    // 翻页
    ProfitHandleCurrentChange(val) {
      this.queryProfit.currentPage = val;
      this.getProfit();
    },
    // 计算利润
    getExpend(actualAmt, cost, refundAmt) {
      return Number(BN(Number(actualAmt)).minus(Number(cost)).minus(Number(refundAmt)));
    },
    // 获取优惠金额
    getDisAmt(row) {
      const number = Number(BN(Number(row.discountAmt)).plus(Number(row.couponDiscountAmt)).plus(Number(row.wipeAmt)));
      return number;
    },
    // 导出
    fileExport() {
      let time = 0;
      if (this.time2[1] && this.time2[0]) {
        time = Math.floor((new Date(this.time2[1]) - new Date(this.time2[0])) / 1000 / 60 / 60 / 24);
      }
      if (this.profitTableData.length < 1) {
        this.$alert('没有订单信息，请更换查询条件试试', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else if (time > 365) {
        this.$alert('导出时间不能超过一年', '提示', {
          confirmButtonText: '确定',
        }).catch(() => {
        });
      } else {
        this.$api.statistic.orderProfitExport(this.queryProfit);
      }
    },
    // 筛选触发事件
    queryChangeHandle() {
      this.setPath({
        time2: this.time2,
        doctorId2: this.queryProfit.doctorId,
        orderType2: this.queryProfit.orderType,
        payMode2: this.queryProfit.payMode,
        currentPage2: this.queryProfit.currentPage,
        active: this.active,
        activeS: this.activeS,
      });
    },
    // 通过url初始化筛选项
    initQuery() {
      const queryUrl = this.getPath();
      this.time2 = queryUrl.time2 ? queryUrl.time2 : setToday();
      this.queryProfit.doctorId = queryUrl.doctorId2 ? Number(queryUrl.doctorId2) : null;
      this.queryProfit.orderType = queryUrl.orderType2 ? Number(queryUrl.orderType2) : 0;
      this.queryProfit.payMode = queryUrl.payMode2 ? Number(queryUrl.payMode2) : 0;
      this.queryProfit.currentPage = queryUrl.currentPage2 ? Number(queryUrl.currentPage2) : 1;
      this.active = queryUrl.active ? Number(queryUrl.active) : 0;
      this.activeS = queryUrl.activeS ? Number(queryUrl.activeS) : 0;
      this.getProfit();
    },
  },
  mounted() {
    this.getDoctorId();
    this.initQuery();
  },
  filters: {
    getOrderType(type) {
      let opType = '';
      switch (type) {
        case 1: opType = '门诊病历';
          break;
        case 2: opType = '直接售药';
          break;
        case 3: opType = '挂号';
          break;
        default: opType = '';
          break;
      }
      return opType;
    },
  },
  watch: {
  },
};
